import type { ReactNode } from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { useAppSelector } from '@/stores/hooks';
import { selectStaffRef } from '@/stores/selectors';

const PUBLIC_PATHS = new Set(['/staff-required']);

type StaffSurveyGateProps = {
  children: ReactNode;
};

export default function StaffSurveyGate({ children }: StaffSurveyGateProps) {
  const staffRef = useAppSelector(selectStaffRef);
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const refInUrl = searchParams.get('ref')?.trim();

  if (PUBLIC_PATHS.has(pathname)) {
    return children;
  }

  if (!staffRef?.staffCode) {
    if (refInUrl) {
      return (
        <div className="flex min-h-[50vh] items-center justify-center text-slate-500">
          Verifying promoter code…
        </div>
      );
    }
    return <Navigate to="/staff-required" replace />;
  }

  return children;
}
